import { addAPIProvider } from '@iconify/react';

const iconifyApiPath = import.meta.env.VITE_ICONIFY_API_PATH?.trim() || '/iconify';

// Provider عمومی با سرویس هم‌مبدأ و کاملاً محلی جایگزین می‌شود؛ بنابراین
// هیچ آیکنی از api.iconify.design یا CDN دریافت نخواهد شد.
addAPIProvider('', {
  resources: [iconifyApiPath],
  path: '/',
  maxURL: 1200,
  rotate: 750,
  timeout: 10000,
  random: false,
  dataAfterTimeout: false,
});

export const ICONIFY_API_PATH = iconifyApiPath;
